import React from 'react'
// TODO: Import these types when cxgenie service is migrated
// import { ChatSession } from '../services/cxgenie/chat-session.type'
// import { ChatFormResultField } from '../services/cxgenie'

// Temporary placeholder types until services are migrated
type ChatSession = any
type ChatFormResultField = any

interface MessageItemContextValues {
  message?: any
  isMine?: boolean
  isSocial?: boolean
  isBlock?: boolean
  selectedChatSession?: ChatSession | null
  renderViewStatus?: () => React.ReactNode
  renderMessageTime?: () => string | null
  renderTextField?: (field: Partial<ChatFormResultField>) => string
  renderUploadedFile?: (file: { name: string; url: string; type: string }) => JSX.Element | undefined
}

const MessageItemContext = React.createContext<MessageItemContextValues>({})

export default MessageItemContext
